'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgWrapper = require('../../../core/SvgWrapper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PaintIcon = function PaintIcon(props) {
  return React__default["default"].createElement(SvgWrapper, _objectSpread({}, props), React__default["default"].createElement("g", {
    fillRule: 'evenodd',
    transform: 'translate(-6 -3)'
  }, React__default["default"].createElement("path", {
    fill: '#2196F3',
    fillRule: 'nonzero',
    d: 'M28.5,6.33333333 L28.5,4.75 C28.5,3.87916667 27.7875,3.16666667 26.9166667,3.16666667 L7.91666667,3.16666667 C7.04583333,3.16666667 6.33333333,3.87916667 6.33333333,4.75 L6.33333333,11.0833333 C6.33333333,11.9541667 7.04583333,12.6666667 7.91666667,12.6666667 L26.9166667,12.6666667 C27.7875,12.6666667 28.5,11.9541667 28.5,11.0833333 L28.5,9.5 L30.0833333,9.5 L30.0833333,15.8333333 L14.25,15.8333333 L14.25,33.25 C14.25,34.1208333 14.9625,34.8333333 15.8333333,34.8333333 L19,34.8333333 C19.8708333,34.8333333 20.5833333,34.1208333 20.5833333,33.25 L20.5833333,19 L33.25,19 L33.25,6.33333333 L28.5,6.33333333 Z'
  }), React__default["default"].createElement("polygon", {
    points: '0 0 38 0 38 38 0 38'
  })));
};

module.exports = PaintIcon;
